import { Injectable, inject } from '@angular/core';
import { FilesService } from './files.service';
import { DocStateService } from './doc-state.service';
import { catchError, of } from 'rxjs';
import { PdfOptions } from '@/models/binder-file';
import { DocDataService } from '../app/doc-data.service';
import { ObjectSnapshotService } from '../app/object-snapshot.service';

@Injectable({ providedIn: 'root' })
export class DocGeneratorService {
  private filesService = inject(FilesService);
  private docState = inject(DocStateService);
  docDataService = inject(DocDataService);
  private objectSnapshotService = inject(ObjectSnapshotService);

  generateSelected(): void {
    const categories = this.filesService.categories().filter(cat => cat.categorySelected);
    const selectedTemplates = this.docState.selectedTemplateIds();
    const data = this.docDataService.jsonData();

    for (const cat of categories) {
      cat.generating = true;
      cat.error = false;
      cat.errorMessage = '';
    }

    for (const cat of categories) {
      const selected = selectedTemplates.find(st => st.fileCategoryId === cat.fileCategoryId);
      const template = cat.fileTemplates.find(t => t.fileTemplateId === selected?.selectedTemplateId);
      if (!template) continue;

      const config: PdfOptions = {
        format: 'Letter',
        landscape: false,
        printBackground: true,
        scale: 1,
        margin: { top: '80px', right: '50px', bottom: '80px', left: '50px' },
        displayHeaderFooter: true,
        footerTemplate: template.footerTemplate,
        headerTemplate: template.headerTemplate
      };
      if(!data) continue;

      const hash = this.objectSnapshotService.getSnapshotHash(data, template.schemaString);
      const existingFile = cat.binderFiles?.[0];

      this.filesService.generateFile(template, data, hash, config, existingFile?.fileId)
        .pipe(catchError(err => {
          console.error('Doc generation failed:', err);
          return of(null);
        }))
        .subscribe(newFile => {
          if (newFile) {
            this.filesService.linkNewFileToCategory(newFile, cat);
          } else {
            cat.error = true;
            cat.errorMessage = 'Upload failed';
          }
        });
    }
  }
}